module.exports = __webpack_public_path__ + "img/ramn_3kl.50408e10.jpg";